import { useEffect, useState } from "react";
import { useDebounce } from "@/hooks/useDebounce";
import { searchService } from "@/services/searchService";

export function SearchSuggestions({ query, onPick }: { query: string; onPick: (v: string) => void }) {
  const q = useDebounce(query, 200);
  const [items, setItems] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    if (!q) { setItems([]); return; }
    searchService.suggest(q).then((r) => { if (!cancelled) setItems(r); }).catch(() => {});
    return () => { cancelled = true; };
  }, [q]);

  if (!items.length) return null;
  return (
    <ul style={{
      position: "absolute", top: "100%", left: 0, right: 0, marginTop: 4,
      background: "var(--bg-elev-2)", border: "1px solid var(--line)",
      borderRadius: 12, listStyle: "none", padding: 6, zIndex: 30, boxShadow: "var(--shadow)",
    }}>
      {items.map((it) => (
        <li key={it}>
          <button onMouseDown={() => onPick(it)} style={{ width: "100%", textAlign: "left", padding: "8px 10px", borderRadius: 8 }}>
            {it}
          </button>
        </li>
      ))}
    </ul>
  );
}
